import toDate from "../toDate/index.mjs";
import differenceInCalendarYears from "../differenceInCalendarYears/index.mjs";
import compareAsc from "../compareAsc/index.mjs";
import requiredArgs from "../_lib/requiredArgs/index.mjs";
function differenceInYears(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var sign = compareAsc(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarYears(dateLeft, dateRight));
  dateLeft.setFullYear(1584);
  dateRight.setFullYear(1584);
  var isLastYearNotFull = compareAsc(dateLeft, dateRight) === -sign;
  var result = sign * (difference - Number(isLastYearNotFull));
  return result === 0 ? 0 : result;
}
export {
  differenceInYears as default
};
